export const ALLOWED_ROUTE_LABELS = [
  'Dashboard',
  'Calendar',
  'Forms',
  'Chat',
  'AI Magic',
  'Checklists',
  'Your Page',
  'Purchase',
  'Notifications',
  'User Settings',
  'Workspace Settings',
  'Command & Experience Hub',
  'General',
  'Security',
  'Billing',
  'App Guides',
  'Interactive Tours',
  'Feedback Center',
  'Appearance & Engine',
] as const

export const ALLOWED_ACTION_LABELS = [
  'Begin Journey',
  'Replay Tour',
  'Next',
  'Back',
  'Close',
  'Skip',
  'Generate',
  'Send',
  'Plan',
  'Action',
  'Transfer Credits',
  'Deposit',
  'Withdraw',
  'Submit',
  'Click',
  'Open',
  'Type',
  'Review',
] as const

export const LOCALIZATION_LABEL_ALLOWLIST = new Set<string>([
  ...ALLOWED_ROUTE_LABELS,
  ...ALLOWED_ACTION_LABELS,
])

const uiLabelPattern = /\b([A-Z][A-Za-z0-9&+]*(?:\s+[A-Z][A-Za-z0-9&+]*){0,3})\s+(?:button|tile|panel|modal|route|path|page|action|control)\b/g
const quotedLabelPattern = /["'“”]([^"'“”]{2,48})["'“”]/g
const pathPattern = /(?:^|\s)(\/(?:admin|member|workspace|settings)[^\s]*)/gi

const normalizeLabel = (value: string) => value.replace(/\s+/g, ' ').trim()

export const findUnauthorizedLocalizedLabel = (value: string): string | null => {
  const source = value.trim()
  if (!source) return null

  for (const match of source.matchAll(pathPattern)) {
    const candidate = normalizeLabel(match[1] ?? '')
    if (candidate && !LOCALIZATION_LABEL_ALLOWLIST.has(candidate)) return candidate
  }

  for (const match of source.matchAll(quotedLabelPattern)) {
    const candidate = normalizeLabel(match[1] ?? '')
    if (candidate && /(?:button|tile|panel|modal|route|path|page|action|admin|forge|raid)/i.test(candidate) && !LOCALIZATION_LABEL_ALLOWLIST.has(candidate)) {
      return candidate
    }
  }

  for (const match of source.matchAll(uiLabelPattern)) {
    const candidate = normalizeLabel(match[1] ?? '')
    if (candidate && !LOCALIZATION_LABEL_ALLOWLIST.has(candidate)) return candidate
  }

  return null
}
